import { CLIENT_SETTINGS_KEY } from '../../../../constants';
import { ClientSettingsType, WebNotificationType } from '../../../types';

/**
 * This method retrieves notifications props from clientSettings and saves default value to localStorage if props not exist.
 * Method is safe to use as initialize clientcache if it was not previously set.
 */
export const initNotificationsClientSettings = (): void => {
  const originalClientSettings = localStorage.getItem(CLIENT_SETTINGS_KEY);
  let clientSettings = JSON.parse(originalClientSettings);
  if (!clientSettings) {
    clientSettings = {
      didPresentNotificationQuestion: false,
    };
  }
  if (!clientSettings[WebNotificationType.newsfeedNotifications]) {
    clientSettings[WebNotificationType.newsfeedNotifications] = null;
  }
  if (!clientSettings[WebNotificationType.notifications]) {
    clientSettings[WebNotificationType.notifications] = null;
  }

  const stringifiedClientSettings = JSON.stringify(clientSettings);
  localStorage.setItem(CLIENT_SETTINGS_KEY, stringifiedClientSettings);

  dispatchClientSettingsStorageEvent(originalClientSettings, stringifiedClientSettings);
};

/**
 * This method retrieves clientSettings from localStorage.
 */
export const getClientSettings = (): ClientSettingsType => {
  const clientSettings = JSON.parse(localStorage.getItem(CLIENT_SETTINGS_KEY));

  return clientSettings;
};

/**
 * This method retrieves and update clientSettings property and saves it back to localStorage.
 * @param settings object of setings example: {newsfeedNotifications: true}
 */
export const updateClientSetings = (settings: Partial<ClientSettingsType>): void => {
  const stringifiedClientSettings = localStorage.getItem(CLIENT_SETTINGS_KEY);
  const clientSettings = JSON.parse(stringifiedClientSettings);

  const updatedSettings = { ...clientSettings, ...settings };
  const stringifiedUpdatedSettings = JSON.stringify(updatedSettings);
  localStorage.setItem(CLIENT_SETTINGS_KEY, stringifiedUpdatedSettings);

  dispatchClientSettingsStorageEvent(stringifiedClientSettings, stringifiedUpdatedSettings);
};

// window storage event won't be called in the same window/tab where the change happend
// This is a workaround to synchronize angular's $localStorage data, when changes
// happened outside angular's env.
// This solution may cause duplicated 'storage' event on the other tabs/windows where
// the app is running.
const dispatchClientSettingsStorageEvent = (oldValue: string | null, newValue: string) => {
  const event = new StorageEvent('storage', {
    key: 'ngStorage-clientsettings',
    newValue,
    oldValue,
  });

  // for some reason manually dispatched event causes angular $digest error
  // this fixed the issue
  setTimeout(() => {
    window.dispatchEvent(event);
  });
};
